/* ============================================================
   ARTLEAP — Apple HIG の型の動き（2026-09-29）
   ・下のバー：下へスクロールで縮む／作品ページでは購入ボタンが入る／検索の丸が伸びる
   ・シート（スマホ：下から medium→large、PC：中央のダイアログ）
   ・音声ガイド：再生画面＋文字起こし。ページを移っても続きから（sessionStorage）
   ・作品の拡大表示（ピンチ・ダブルタップ・下へ払って戻る）
   ・棚の作品を長押しでプレビュー（PCは右クリック）
   ・予算の切り替え／部屋での大きさ／展示カードが全画面に広がる
   外部ライブラリなし。要素が無ければ何もしない。
   ============================================================ */
(function () {
  'use strict';
  /* 画面の文言：layout/theme.liquid → snippets/i18n-js が window.__i18n.hig に言語ごとの文言を入れる。無ければ日本語の既定（2026-10-25） */
  var I18N = (window.__i18n && window.__i18n.hig) || {};
  function T(k, d) { var v = I18N[k]; return (v == null || v === '') ? d : v; }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 760px)');
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  /* 開始の状態を確定させてから終わりの状態へ（rAF が止まる裏タブでも動く） */
  var kick = function (fn) { void document.body.offsetWidth; fn(); };
  var yen = function (n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var ss = {
    get: function (k) { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- 前面に出ている物（シート・拡大・長押し・展示）の数。1つでもあれば下のバーを隠す ---------- */
  var layers = 0;
  function layer(on) {
    layers = Math.max(0, layers + (on ? 1 : -1));
    document.body.classList.toggle('hg-modal', layers > 0);
    /* PC の慣性スクロール（Lenis）は、前面に物が出ている間は止める（後ろのページが動かないように）。
       前面の中身は data-lenis-prevent でブラウザ本来のスクロールに任せる（2026-09-30） */
    var L = window.lenis;
    if (L) { try { if (layers > 0) L.stop(); else L.start(); } catch (e) {} }
  }
  /* Lenis にホイールを取られないよう、前面に出る物には data-lenis-prevent を付ける */
  function noLenis(el) { if (el && el.setAttribute) el.setAttribute('data-lenis-prevent', ''); }

  /* ---------- シート ---------- */
  var scrim = document.createElement('div');
  scrim.className = 'hg-scrim';
  document.body.appendChild(scrim);
  var cur = null;
  var sheets = {};
  $$('[data-hg-sheet]').forEach(function (el) {
    document.body.appendChild(el);   /* 変形した親の中に閉じ込められないよう body 直下へ */
    noLenis(el);
    sheets[el.id] = { el: el, det: (el.getAttribute('data-detents') || 'medium').split(' ') };
  });
  function hFor(d) {
    var H = window.innerHeight;
    if (d === 'large') return H - 54;
    return Math.round(Math.min(Math.max(H * 0.56, 430), H - 110));
  }
  function applyDet(d) {
    if (!cur) return;
    cur.d = d;
    cur.el.setAttribute('data-det', d);
    if (MOBILE.matches) cur.el.style.height = hFor(d) + 'px'; else cur.el.style.height = '';
    scrim.classList.toggle('is-deep', d === 'large');
  }
  function openSheet(id, det) {
    var s = sheets[id];
    if (!s) return;
    if (cur && cur.id === id) return;
    if (cur) closeSheet(true);
    cur = { id: id, el: s.el, det: s.det, d: null };
    s.el.hidden = false;
    s.el.classList.add('is-enter');
    applyDet(det || s.det[0]);
    scrim.classList.add('is-on');
    if (stOpen) scrim.classList.add('is-top');
    layer(true);
    s.el.dispatchEvent(new CustomEvent('hg:open', { bubbles: true }));
    kick(function () { s.el.classList.remove('is-enter'); });
    var x = s.el.querySelector('.hg-x');
    if (x && !MOBILE.matches) x.focus({ preventScroll: true });
  }
  function closeSheet(instant) {
    if (!cur) return;
    var el = cur.el;
    cur = null;
    /* PC で展示パネルの上から閉じたときは、パネルの後ろの幕は残す */
    scrim.classList.remove('is-top');
    if (stOpen && !MOBILE.matches) scrim.classList.add('is-deep'); else scrim.classList.remove('is-on', 'is-deep');
    layer(false);
    var done = function () { el.hidden = true; el.classList.remove('is-leave'); };
    if (instant || RM.matches) { done(); return; }
    el.classList.add('is-leave');
    setTimeout(done, 420);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-hg-open]');
    if (o) { e.preventDefault(); openSheet(o.getAttribute('data-hg-open')); return; }
    if (e.target.closest('[data-hg-close]')) { closeSheet(); }
  });
  scrim.addEventListener('click', function () { if (cur) closeSheet(); else closeStory(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet(); closeViewer(); closeCtx(); closeSearch(); closeStory(); } });
  $$('.hg-sheet__top').forEach(function (top) {
    var st = null;
    top.addEventListener('pointerdown', function (e) {
      if (!MOBILE.matches || e.target.closest('.hg-x') || !cur) return;
      st = { y: e.clientY, h: cur.el.getBoundingClientRect().height, ly: e.clientY, lt: performance.now(), v: 0 };
      cur.el.classList.add('is-drag');
      top.setPointerCapture(e.pointerId);
    });
    top.addEventListener('pointermove', function (e) {
      if (!st || !cur) return;
      var maxH = hFor('large'), nh = st.h - (e.clientY - st.y);
      if (nh > maxH) nh = maxH + (nh - maxH) * 0.2;
      cur.el.style.height = Math.max(80, nh) + 'px';
      var now = performance.now();
      st.v = (e.clientY - st.ly) / Math.max(1, now - st.lt); st.ly = e.clientY; st.lt = now;
    });
    function end(e) {
      if (!st || !cur) { st = null; return; }
      cur.el.classList.remove('is-drag');
      var hNow = cur.el.getBoundingClientRect().height, v = st.v, moved = Math.abs(e.clientY - st.y);
      st = null;
      if (moved < 5) { applyDet(cur.det.length > 1 ? (cur.d === 'large' ? 'medium' : 'large') : cur.d); return; }
      var opts = cur.det.map(function (d) { return { d: d, h: hFor(d) }; });
      var minH = Math.min.apply(null, opts.map(function (o) { return o.h; }));
      if (v > 0.9 || hNow < minH * 0.66) { closeSheet(); return; }
      var t = opts.reduce(function (a, b) { return Math.abs(b.h - hNow) < Math.abs(a.h - hNow) ? b : a; }).d;
      if (v < -0.5 && cur.det.indexOf('large') > -1) t = 'large';
      else if (v > 0.45 && cur.d === 'large' && cur.det.indexOf('medium') > -1) t = 'medium';
      applyDet(t);
    }
    top.addEventListener('pointerup', end);
    top.addEventListener('pointercancel', end);
  });
  window.addEventListener('resize', function () { if (cur) applyDet(cur.d); });

  /* ---------- 下のバー ---------- */
  var dock = $('[data-hg-dock]');
  var buyAnchor = $('[data-hg-buy-anchor]');
  function updAcc() {
    if (!dock) return;
    /* 音声ガイドの小さなプレイヤーは「再生している間だけ」出す（2026-09-29 菅原「ずっと付いてくるのが鬱陶しい」）。
       止めたら消え、作品ページでは購入ボタン（購入ボタンが画面の上に流れた後）に戻る */
    var playing = !!(au && !au.paused), m = 'none';
    if (playing) m = 'audio';
    else if (buyAnchor && dock.querySelector('.hg-acc--buy') && buyAnchor.getBoundingClientRect().bottom < 4) m = 'buy';
    if (dock.getAttribute('data-acc') !== m) dock.setAttribute('data-acc', m);
    dock.classList.toggle('has-audio', playing);
  }
  if (dock) {
    document.body.classList.add('has-hg-dock');
    var lastY = window.pageYOffset, accum = 0, ticking = false;
    var setState = function (s) { if (dock.getAttribute('data-state') !== s) dock.setAttribute('data-state', s); };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset, dy = y - lastY;
        lastY = y;
        if (y < 80) { accum = 0; setState('full'); }
        else {
          accum = (dy > 0) === (accum > 0) ? accum + dy : dy;
          if (accum > 10) setState('min'); else if (accum < -10) setState('full');
        }
        updAcc();
      });
    }, { passive: true });
    var mini = $('[data-hg-mini]', dock);
    if (mini) mini.addEventListener('click', function () { accum = 0; setState('full'); });
    var on = $('.hg-tab.is-on', dock), pill = $('.hg-dock__pill', dock);
    if (on) dock.style.setProperty('--i', $$('.hg-tab', dock).indexOf(on));
    else if (pill) pill.classList.add('is-none');
    updAcc();
  }

  /* ---------- 検索（右下の丸が検索欄に伸びる） ---------- */
  noLenis($('[data-hg-search]'));
  var sPanel = $('[data-hg-search]'), sInput = dock ? $('[data-hg-q]', dock) : null, sRes = $('[data-hg-res]'), sRecent = $('[data-hg-recent]');
  var sTimer = null, sOpen = false;
  var RKEY = 'ah-hg-recent';
  function recentList() { try { return JSON.parse(window.localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } }
  function remember(q) {
    if (!q) return;
    var l = recentList().filter(function (x) { return x !== q; });
    l.unshift(q);
    try { window.localStorage.setItem(RKEY, JSON.stringify(l.slice(0, 5))); } catch (e) {}
  }
  function paintRecent() {
    if (!sRecent) return;
    var l = recentList();
    sRecent.hidden = !l.length;
    var box = $('[data-hg-recent-list]', sRecent);
    if (box) box.innerHTML = l.map(function (q) { return '<button type="button" data-q="' + esc(q) + '"><svg class="hg-i"><use href="#hg-hist"/></svg>' + esc(q) + '</button>'; }).join('');
  }
  function openSearch() {
    if (!dock || !sPanel || sOpen) return;
    sOpen = true;
    dock.setAttribute('data-state', 'full');
    dock.classList.add('is-search');
    sPanel.hidden = false;
    paintRecent();
    document.documentElement.classList.add('hg-noscroll');
    kick(function () { sPanel.classList.add('is-on'); });
    sInput.tabIndex = 0;
    setTimeout(function () { sInput.focus({ preventScroll: true }); }, 60);
  }
  function closeSearch() {
    if (!sOpen) return;
    sOpen = false;
    dock.classList.remove('is-search');
    sPanel.classList.remove('is-on');
    document.documentElement.classList.remove('hg-noscroll');
    sInput.blur();
    sInput.tabIndex = -1;
    setTimeout(function () { if (!sOpen) sPanel.hidden = true; }, 380);
  }
  function runSearch(q) {
    if (!sRes) return;
    if (!q) { sRes.innerHTML = ''; if (sRecent) paintRecent(); return; }
    if (sRecent) sRecent.hidden = true;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (sInput.value.trim() !== q) return;
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!ps.length) { sRes.innerHTML = '<p class="hg-res__none">' + T('search_empty', '見つかりませんでした。別の言葉でお試しください。') + '</p>'; return; }
        sRes.innerHTML = ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          var price = p.price ? '¥' + Math.round(parseFloat(p.price)).toLocaleString('ja-JP') : '';
          return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
            '<b>' + esc(p.title) + '</b><i>' + esc(p.vendor || '') + '</i><span>' + (p.available ? price : ((p.tags || []).indexOf('upcoming') > -1 ? T('upcoming_prefix', '販売前・') + price : 'SOLD')) + '</span></a>';
        }).join('') + '<a class="hg-res__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">' + T('search_all', '「{q}」の結果をすべて見る').replace('{q}', esc(q)) + '</a>';
      })
      .catch(function () {});
  }
  if (dock && sPanel && sInput) {
    $('[data-hg-sbtn]', dock).addEventListener('click', function () { if (sOpen) { sInput.focus(); } else { openSearch(); } });
    $('[data-hg-sx]', dock).addEventListener('click', closeSearch);
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      sTimer = setTimeout(function () { runSearch(q); }, 180);
    });
    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { var q = sInput.value.trim(); if (q) { remember(q); window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; } }
    });
    sPanel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) { sInput.value = b.getAttribute('data-q'); runSearch(sInput.value); return; }
      var a = e.target.closest('a[href]');
      if (a && sInput.value.trim()) remember(sInput.value.trim());
    });
  }

  /* ---------- 音声ガイド（どのページでも続きから） ---------- */
  var AKEY = 'ah-hg-audio';
  var au = null, aState = null, lines = [], lnEls = [], curLine = -2, userScroll = 0, litLine = -1, litN = -1, dotsEl = null;
  /* 再生を GA4 に知らせる（2026-10-07）。new Audio() はページの中に無いので、analytics.liquid の 'play' 監視に届かない
     → 押したボタンから hg:audio-play を出し、analytics.liquid が audio_play として送る */
  var aTrig = null;
  function announcePlay() {
    var t = aTrig && document.documentElement.contains(aTrig) ? aTrig : document.body;
    try { t.dispatchEvent(new CustomEvent('hg:audio-play', { bubbles: true, detail: { title: aState ? aState.title || '' : '' } })); } catch (err) {}
  }
  var player = $('#hg-player');
  function fmt(s) { s = Math.max(0, Math.round(s || 0)); return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2); }
  function timings(st) {
    var L = [];
    /* 一文は「文字列」か「{t: 文字, s: 始まる秒}」。録音から取った秒があればそれを使う（2026-09-29：原稿と録音がずれていたため） */
    (st.paras || []).forEach(function (p, pi) { p.forEach(function (x) { L.push(typeof x === 'string' ? { t: x, p: pi } : { t: String(x.t || ''), p: pi, s: +x.s, e: +x.e }); }); });
    if (!L.length) return L;
    if (L.every(function (l) { return l.s >= 0; })) return lineEnds(L, st);
    L.forEach(function (l) { delete l.s; });
    var r0 = st.range ? st.range[0] : 0, r1 = st.range ? st.range[1] : (au && au.duration) || 0;
    var GAPL = 0.45, GAPP = 1.0, gaps = 0;
    var lens = L.map(function (l) { return l.t.replace(/\s/g, '').length; });
    var tot = lens.reduce(function (a, b) { return a + b; }, 0) || 1;
    L.forEach(function (l, i) { if (i) gaps += l.p !== L[i - 1].p ? GAPP : GAPL; });
    var speak = Math.max(1, r1 - r0 - gaps), t = r0;
    L.forEach(function (l, i) { if (i) t += l.p !== L[i - 1].p ? GAPP : GAPL; l.s = t; t += lens[i] / tot * speak; l.e = t; });
    return lineEnds(L, st);
  }
  /* 行の終わり（e）。録音から取った e が無い文字起こし（景・パサージュ）は、次の行の出だしの少し前で終わったことにする。
     Apple Music の歌詞のように、行の中を e までに左から光らせるのに使う（2026-11-02 norizo） */
  function lineEnds(L, st) {
    var last = st.range ? st.range[1] : (au && au.duration) || 0;
    L.forEach(function (l, i) {
      var nx = i < L.length - 1 ? L[i + 1].s - 0.35 : last;
      if (!(l.e > l.s)) l.e = nx > l.s ? nx : l.s + Math.max(1.5, l.t.length * 0.14);
      l.e = Math.max(l.e, l.s + 0.6);
    });
    return L;
  }
  /* 1文字ずつ span にして、読み上げの位置まで白くする。句読点・括弧は時間を使わない、英数字は仮名の約半分 */
  function lyrLine(l, i) {
    var cs = Array.from(l.t), w = cs.map(function (c) { return /[\s、。，．,.!?！？「」『』（）()・…—_]/.test(c) ? 0 : /[A-Za-z0-9]/.test(c) ? 0.55 : 1; });
    var tot = w.reduce(function (a, b) { return a + b; }, 0) || 1, acc = 0;
    l.cum = w.map(function (x) { acc += x; return acc / tot; });
    return '<button type="button" class="hg-lyr__ln" data-i="' + i + '">' + cs.map(function (c) { return '<span class="hg-lyr__c">' + esc(c) + '</span>'; }).join('') + '</button>';
  }
  function fillLine(i, ct) {
    if (i < 0 || !lines[i] || !lnEls[i]) { litLine = -1; litN = -1; return; }
    var l = lines[i], f = Math.min(1, Math.max(0, (ct - l.s) / (l.e - l.s))), n = 0;
    while (n < l.cum.length && l.cum[n] <= f + 1e-6) n++;
    /* 光った文字の直後に続く句読点も一緒に光らせる */
    while (n > 0 && n < l.cum.length && l.cum[n] === l.cum[n - 1]) n++;
    if (i === litLine && n === litN) return;
    litLine = i; litN = n;
    $$('.hg-lyr__c', lnEls[i]).forEach(function (c, k) { c.classList.toggle('is-lit', k < n); });
  }
  function paintPlayer() {
    if (!player || !aState) return;
    var bg = $('.hg-player__bg', player);
    if (bg && aState.art) bg.style.backgroundImage = 'url("' + aState.art + '")';
    var im = $('[data-hg-pl-art]', player); if (im && aState.art) im.src = aState.art;
    var t = $('[data-hg-pl-title]', player); if (t) t.textContent = aState.title || T('audio_guide', '音声ガイド');
    var s = $('[data-hg-pl-sub]', player); if (s) s.textContent = aState.sub || '';
    var lyr = $('[data-hg-lyr]', player);
    lines = timings(aState);
    /* 文字起こしが無い音声（作家ごとのガイドなど）は、真ん中が空かないよう写真を大きく出す（2026-10-05） */
    player.classList.toggle('is-nolyr', !lines.length);
    if (lyr) {
      if (!lines.length) { lyr.innerHTML = ''; }
      else {
        /* 声が出るまでの前奏は「•••」を脈打たせる（Apple Music の間奏の印） */
        var html = lines[0].s > 1.5 ? '<div class="hg-lyr__dots" aria-hidden="true"><i></i><i></i><i></i></div>' : '', lastP = -1;
        lines.forEach(function (l, i) { if (l.p !== lastP && lastP >= 0) html += '<div class="hg-lyr__gap"></div>'; lastP = l.p; html += lyrLine(l, i); });
        lyr.innerHTML = html;
      }
      lnEls = $$('.hg-lyr__ln', lyr);
      dotsEl = $('.hg-lyr__dots', lyr);
      curLine = -2; litLine = -1; litN = -1;
    }
    var at = dock ? $('[data-hg-acc-title]', dock) : null; if (at) at.textContent = aState.title || T('audio_guide', '音声ガイド');
    var ai = dock ? $('[data-hg-acc-art]', dock) : null; if (ai && aState.art) ai.src = aState.art;
  }
  function syncLines(force) {
    if (!au || !lines.length) return;
    var ct = au.currentTime, i = -1;
    for (var j = 0; j < lines.length; j++) if (ct >= lines[j].s - 0.2) i = j;
    var lyr = player && $('[data-hg-lyr]', player);
    /* 指で歌詞を送っている間はぼかしを外す（Apple Music と同じ） */
    if (lyr) lyr.classList.toggle('is-free', performance.now() - userScroll < 3000);
    fillLine(i, ct);
    if (i === curLine && !force) return;
    curLine = i;
    if (dotsEl) dotsEl.classList.toggle('is-on', i < 0);
    lnEls.forEach(function (el, k) { el.classList.toggle('is-on', k === i); el.classList.toggle('is-past', k < i); });
    if (lyr && i >= 0 && performance.now() - userScroll > 3000 && cur && cur.id === 'hg-player') {
      lyr.scrollTo({ top: lnEls[i].offsetTop - lyr.clientHeight * 0.28, behavior: RM.matches ? 'auto' : 'smooth' });
    }
  }
  function tick() {
    if (!au || !player) return;
    var d = au.duration || 0, c = au.currentTime;
    var sc = $('[data-hg-scrub]', player);
    if (sc) sc.style.setProperty('--p', d ? Math.min(1, c / d) : 0);
    var a = $('[data-hg-tcur]', player), b = $('[data-hg-trem]', player);
    if (a) a.textContent = fmt(c);
    if (b) b.textContent = '-' + fmt(d - c);
    /* ページ内の音声カード（展示ページ）の進み具合も合わせる（2026-10-05） */
    $$('[data-hg-prog]').forEach(function (el) {
      if (el.getAttribute('data-src') !== aState.src) return;
      el.style.setProperty('--p', d ? Math.min(1, c / d) : 0);
      var pc = $('[data-hg-pc]', el), pd = $('[data-hg-pd]', el);
      if (pc) pc.textContent = fmt(c);
      if (pd && d) pd.textContent = fmt(d);
    });
    syncLines();
    if (!au.paused) window.requestAnimationFrame(tick);
  }
  function setPlayUI(on) {
    var href = on ? '#hg-pause' : '#hg-play';
    $$('[data-hg-pp] use').forEach(function (u) { u.setAttribute('href', href); });
    $$('[data-hg-pp]').forEach(function (b) { b.setAttribute('aria-label', on ? T('pause', '一時停止') : T('play', '再生')); });
    /* 同じページに音声ボタンが複数ある時（展示ページの作家ごとのガイド）は、いま流れている音声のボタンだけを再生中に */
    $$('[data-hg-audio]').forEach(function (b) { var s = b.getAttribute('data-src'); b.classList.toggle('is-playing', on && (!s || !aState || s === aState.src)); });
  }
  function save() { if (au && aState) { aState.t = au.currentTime; aState.rate = au.playbackRate; ss.set(AKEY, aState); } }
  function ensureAudio(st, startAt) {
    if (!au) {
      au = new Audio();
      au.preload = 'metadata';
      au.addEventListener('play', function () { setPlayUI(true); updAcc(); window.requestAnimationFrame(tick); announcePlay(); });
      au.addEventListener('pause', function () { setPlayUI(false); save(); updAcc(); });
      au.addEventListener('ended', function () { setPlayUI(false); ss.del(AKEY); updAcc(); });
      au.addEventListener('loadedmetadata', function () { if (aState && !aState.range) paintPlayer(); tick(); });
      window.addEventListener('pagehide', save);
    }
    if (!aState || aState.src !== st.src) {
      aState = st;
      au.src = st.src;
      if (startAt) au.addEventListener('loadedmetadata', function once() { au.currentTime = startAt; au.removeEventListener('loadedmetadata', once); tick(); });
    }
    paintPlayer();
    updAcc();
  }
  function play() {
    if (!au) return;
    var p = au.play();
    if (p && p.catch) p.catch(function () {});
  }
  function openPlayer() {
    if (!player) return;
    openSheet('hg-player');
    window.requestAnimationFrame(function () { syncLines(true); tick(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hg-audio]');
    if (!b) return;
    e.preventDefault();
    aTrig = b;
    var src = $(b.getAttribute('data-hg-audio'));
    var st = null;
    try { st = JSON.parse(src ? src.textContent : 'null'); } catch (err) { st = null; }
    if (!st || !st.src) return;
    var same = aState && aState.src === st.src;
    /* 別のページで途中まで聴いていたら、その続きから */
    var resume = !aState ? ss.get(AKEY) : null;
    ensureAudio(st, resume && resume.src === st.src ? resume.t || 0 : 0);
    if (resume && resume.src === st.src && resume.rate) au.playbackRate = resume.rate;
    if (!same || au.paused) play();
    openPlayer();
  });
  if (player) {
    $$('[data-hg-pp]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); if (!au) return; if (au.paused) play(); else au.pause(); }); });
    var sk = function (d) { if (!au) return; au.currentTime = Math.max(0, Math.min((au.duration || 0), au.currentTime + d)); userScroll = 0; tick(); };
    var b15 = $('[data-hg-b15]', player), f15 = $('[data-hg-f15]', player), fw = dock ? $('[data-hg-acc-fw]', dock) : null;
    if (b15) b15.addEventListener('click', function () { sk(-15); });
    if (f15) f15.addEventListener('click', function () { sk(15); });
    if (fw) fw.addEventListener('click', function (e) { e.stopPropagation(); sk(15); });
    var speeds = [1, 1.25, 1.5, 0.75], spd = $('[data-hg-speed]', player);
    if (spd) spd.addEventListener('click', function () { if (!au) return; var i = (speeds.indexOf(au.playbackRate) + 1) % speeds.length; au.playbackRate = speeds[i]; spd.textContent = speeds[i] + '×'; });
    var lyr = $('[data-hg-lyr]', player);
    if (lyr) {
      lyr.addEventListener('wheel', function () { userScroll = performance.now(); lyr.classList.add('is-free'); }, { passive: true });
      lyr.addEventListener('touchmove', function () { userScroll = performance.now(); lyr.classList.add('is-free'); }, { passive: true });
      lyr.addEventListener('click', function (e) {
        var l = e.target.closest('.hg-lyr__ln'); if (!l || !au) return;
        au.currentTime = Math.max(0, lines[+l.getAttribute('data-i')].s - 0.1); userScroll = 0; syncLines(true);
        if (au.paused) play();
      });
    }
    var scrub = $('[data-hg-scrub]', player);
    if (scrub) {
      var drag = false;
      var seek = function (e) { if (!au || !au.duration) return; var r = scrub.getBoundingClientRect(); au.currentTime = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)) * au.duration; userScroll = 0; tick(); };
      scrub.addEventListener('pointerdown', function (e) { drag = true; scrub.classList.add('is-drag'); scrub.setPointerCapture(e.pointerId); seek(e); });
      scrub.addEventListener('pointermove', function (e) { if (drag) seek(e); });
      var up = function () { drag = false; scrub.classList.remove('is-drag'); };
      scrub.addEventListener('pointerup', up); scrub.addEventListener('pointercancel', up);
      scrub.addEventListener('keydown', function (e) { if (!au) return; if (e.key === 'ArrowRight') au.currentTime += 5; else if (e.key === 'ArrowLeft') au.currentTime -= 5; else return; e.preventDefault(); tick(); });
    }
    var accT = dock ? $('[data-hg-acc-open]', dock) : null;
    if (accT) accT.addEventListener('click', openPlayer);
    /* 音声カードには、押す前から長さを出しておく（音声の頭の情報だけ読む） */
    $$('[data-hg-prog]').forEach(function (el) {
      var pd = $('[data-hg-pd]', el), s = el.getAttribute('data-src');
      if (!pd || !s) return;
      var m = new Audio(); m.preload = 'metadata';
      m.addEventListener('loadedmetadata', function () { if (isFinite(m.duration) && !pd.textContent) pd.textContent = fmt(m.duration); m.removeAttribute('src'); });
      m.src = s;
    });
    /* 別のページで聴いていた位置は覚えておき、次に音声ガイドを押した時に続きから流す（勝手には出さない・鳴らさない） */
  }

  /* ---------- 作品の拡大表示 ----------
     2026-10-05：同じ作品の画像を左右にめくれる（菅原「拡大しても拡大したまま別画像にスワイプできるように」）。
     ・等倍：横に引くと隣の画像、縦に引くと閉じる。
     ・拡大中：指で動かして画像の端まで来て、さらに引くと隣の画像へ。隣の画像も同じ倍率のまま、入ってきた側の端から見せる。
     ・ページ側の画像の列（data-hp-track）とサムネも同じ画像に合わせておき、閉じるとその画像に戻る。PCは ← → キーでも。 */
  var V = null, vOpen = false, VI = [], vi = 0, sx = 0, z = { tx: 0, ty: 0, s: 1 }, vKeep = -1, vHid = null, VGAP = 24;
  var vw = function () { return window.innerWidth; }, vh = function () { return window.innerHeight; };
  function fitBox(ar) { var w = vw(), h = w / ar; if (h > vh() * 0.86) { h = vh() * 0.86; w = h * ar; } return { x: (vw() - w) / 2, y: (vh() - h) / 2, w: w, h: h }; }
  function edgeX(b, s) { var w = b.w * s; return w > vw() ? { min: vw() - w, max: 0 } : { min: (vw() - w) / 2, max: (vw() - w) / 2 }; }
  function clampPan() {
    var b = VI[vi].b, h = b.h * z.s, e = edgeX(b, z.s), left = Math.min(e.max, Math.max(e.min, b.x + z.tx)), top = b.y + z.ty;
    top = h > vh() ? Math.min(0, Math.max(vh() - h, top)) : (vh() - h) / 2;
    z.tx = left - b.x; z.ty = top - b.y;
  }
  function zoomAt(p, s2) { var b = VI[vi].b, left = b.x + z.tx, top = b.y + z.ty, k = s2 / z.s; z.tx = p.x - (p.x - left) * k - b.x; z.ty = p.y - (p.y - top) * k - b.y; z.s = s2; }
  /* 隣の画像：今の倍率のまま、入ってくる側の端をそろえる。縦は「画面の真ん中に来ている位置の割合」をそろえる */
  function sideZ(j) {
    if (z.s <= 1.01) return { tx: 0, ty: 0, s: 1 };
    var b = VI[j].b, c = VI[vi].b, s = z.s, w = b.w * s, h = b.h * s;
    var left = w > vw() ? (j > vi ? 0 : vw() - w) : (vw() - w) / 2;
    var fy = (vh() / 2 - (c.y + z.ty)) / (c.h * z.s), top = vh() / 2 - fy * h;
    top = h > vh() ? Math.min(0, Math.max(vh() - h, top)) : (vh() - h) / 2;
    return { tx: left - b.x, ty: top - b.y, s: s };
  }
  function tf(el, tx, ty, s) { el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')'; }
  function applyZ() {
    VI.forEach(function (it, j) {
      var d = j - vi;
      if (Math.abs(d) > 1) { it.el.style.visibility = 'hidden'; return; }
      if (!it.el.getAttribute('src') && it.src0) it.el.src = it.src0;
      it.el.style.visibility = '';
      if (!d) { tf(it.el, z.tx + sx, z.ty, z.s); return; }
      var q = j === vKeep ? it.z : sideZ(j);
      tf(it.el, d * (vw() + VGAP) + sx + q.tx, q.ty, q.s);
    });
  }
  function fromEl() { var r = vHid.getBoundingClientRect(), b = VI[vi].b; return { tx: r.left - b.x, ty: r.top - b.y, s: r.width / b.w }; }
  function setCap() {
    $('.hg-viewer__cap', V).textContent = VI[vi].btn.getAttribute('data-cap') || '';
    $('.hg-viewer__dots', V).innerHTML = VI.length > 1 ? VI.map(function (x, j) { return '<i' + (j === vi ? ' class="is-on"' : '') + '></i>'; }).join('') : '';
  }
  function hiRes(j) {
    var it = VI[j]; if (!it || it.hi) return; it.hi = true;
    var full = it.btn.getAttribute('data-full'); if (!full) return;
    var im = new Image(); im.onload = function () { if (vOpen) it.el.src = full; }; im.src = full;
  }
  /* ページ側の列とサムネを、いま見ている画像に合わせる（閉じた時にその画像へ戻るように） */
  function pageTo(j) {
    var it = VI[j], tr = it.btn.closest('[data-hp-track]');
    if (tr) tr.scrollTo({ left: j * tr.clientWidth, behavior: 'auto' });
    $$('[data-hg-thumb]').forEach(function (x, k) { x.classList.toggle('is-on', k === j); });
    if (vHid) vHid.style.visibility = '';
    vHid = $('img', it.btn); if (vHid) vHid.style.visibility = 'hidden';
  }
  function go(n) {
    if (n < 0 || n >= VI.length || n === vi) return false;
    var dir = n > vi ? 1 : -1, nz = sideZ(n);
    VI[vi].z = { tx: z.tx, ty: z.ty, s: z.s }; vKeep = vi;
    vi = n; z = nz; sx += dir * (vw() + VGAP);
    V.classList.remove('is-anim', 'is-slide'); applyZ();
    if (RM.matches) { sx = 0; vKeep = -1; applyZ(); }
    else {
      kick(function () { V.classList.add('is-slide'); sx = 0; applyZ(); });
      clearTimeout(go.t); go.t = setTimeout(function () { V.classList.remove('is-slide'); vKeep = -1; applyZ(); }, 420);
    }
    setCap(); hiRes(n); pageTo(n);
    return true;
  }
  function buildViewer() {
    V = document.createElement('div');
    V.className = 'hg-viewer'; V.hidden = true;
    V.innerHTML = '<div class="hg-viewer__bg"></div><div class="hg-viewer__strip"></div><button type="button" class="hg-viewer__x" aria-label="' + T('close', '閉じる') + '"><svg class="hg-i"><use href="#hg-x"/></svg></button><div class="hg-viewer__dots" aria-hidden="true"></div><p class="hg-viewer__cap"></p>';
    document.body.appendChild(V);
    $('.hg-viewer__x', V).addEventListener('click', function () { closeViewer(); });
    var P = new Map(), g = null, lastTap = 0;
    var pt = function (e) { return { x: e.clientX, y: e.clientY, t: e.timeStamp }; };
    /* 両端は少しだけ動いて戻る（その先に画像が無いことが分かるように） */
    var rubber = function (o) { return (o > 0 && vi === 0) || (o < 0 && vi === VI.length - 1) ? o * 0.25 : o; };
    V.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      V.setPointerCapture(e.pointerId); P.set(e.pointerId, pt(e));
      if (V.classList.contains('is-slide') || vKeep >= 0) { clearTimeout(go.t); vKeep = -1; }
      V.classList.remove('is-anim', 'is-slide');
      if (P.size === 2) { sx = 0; applyZ(); var ab = Array.from(P.values()); g = { mode: 'pinch', d0: Math.hypot(ab[0].x - ab[1].x, ab[0].y - ab[1].y), s0: z.s, tx0: z.tx, ty0: z.ty, m0: { x: (ab[0].x + ab[1].x) / 2, y: (ab[0].y + ab[1].y) / 2 } }; }
      else { var p = pt(e); g = { mode: z.s > 1.01 ? 'pan' : 'maybe', x0: p.x, y0: p.y, tx0: z.tx, ty0: z.ty, lx: p.x, lt: p.t, vx: 0 }; }
    });
    V.addEventListener('pointermove', function (e) {
      if (!g || !P.has(e.pointerId)) return;
      P.set(e.pointerId, pt(e));
      if (g.mode === 'pinch' && P.size >= 2) {
        var ab = Array.from(P.values()), d = Math.hypot(ab[0].x - ab[1].x, ab[0].y - ab[1].y), m = { x: (ab[0].x + ab[1].x) / 2, y: (ab[0].y + ab[1].y) / 2 };
        z.s = g.s0; z.tx = g.tx0; z.ty = g.ty0; zoomAt(g.m0, Math.min(5, Math.max(0.8, g.s0 * d / g.d0))); z.tx += m.x - g.m0.x; z.ty += m.y - g.m0.y; applyZ(); return;
      }
      var p = pt(e), dx = p.x - g.x0, dy = p.y - g.y0;
      if (p.t > g.lt) { g.vx = 0.7 * (p.x - g.lx) / (p.t - g.lt) + 0.3 * g.vx; g.lx = p.x; g.lt = p.t; }
      if (g.mode === 'maybe' && Math.hypot(dx, dy) > 6) g.mode = VI.length > 1 && Math.abs(dx) > Math.abs(dy) ? 'swipe' : 'dismiss';
      if (g.mode === 'swipe') { sx = rubber(dx); applyZ(); }
      if (g.mode === 'pan') {
        if (Math.hypot(dx, dy) > 6) g.moved = true;
        var b = VI[vi].b, ed = edgeX(b, z.s), want = b.x + g.tx0 + dx, left = Math.min(ed.max, Math.max(ed.min, want));
        z.tx = left - b.x; z.ty = g.ty0 + dy; sx = VI.length > 1 ? rubber(want - left) : 0; applyZ();
      }
      if (g.mode === 'dismiss') { var bb = VI[vi].b, s = Math.max(0.55, 1 - Math.abs(dy) / (vh() * 1.4)); z.s = s; z.tx = dx + bb.w * (1 - s) / 2; z.ty = dy + bb.h * (1 - s) / 2; applyZ(); V.style.setProperty('--bgo', Math.max(0, 1 - Math.abs(dy) / 320)); }
    });
    function up(e) {
      if (!g) return;
      var p = P.get(e.pointerId) || pt(e);
      P.delete(e.pointerId);
      if (g.mode === 'pinch') {
        if (P.size) { var q = Array.from(P.values())[0]; g = { mode: 'pan', x0: q.x, y0: q.y, tx0: z.tx, ty0: z.ty, lx: q.x, lt: q.t, vx: 0 }; return; }
        V.classList.add('is-anim'); if (z.s < 1) z = { tx: 0, ty: 0, s: 1 }; else clampPan(); applyZ(); g = null; return;
      }
      if (P.size) return;
      var dy = p.y - g.y0;
      /* 拡大中でも、動かさずに2回たたけば元の大きさに戻す（以前は拡大中のダブルタップが効かなかった） */
      if (g.mode === 'maybe' || (g.mode === 'pan' && !g.moved)) {
        var now = performance.now();
        if (now - lastTap < 320) { V.classList.add('is-anim'); sx = 0; if (z.s > 1.01) z = { tx: 0, ty: 0, s: 1 }; else { zoomAt(p, 2.6); clampPan(); } applyZ(); lastTap = 0; }
        else { lastTap = now; if (g.mode === 'pan') { V.classList.add('is-anim'); sx = 0; clampPan(); applyZ(); } }
      }
      else if (g.mode === 'swipe' || g.mode === 'pan') {
        /* 2割以上引いたか、はじいたら隣へ。それ以外は元の位置に戻す */
        /* 拡大中は、端まで勢いよく動かしただけで隣へ行かないよう、はじきは端から30px以上引いた時だけ */
        var th = vw() * 0.18, fl = Math.abs(g.vx) > 0.45, mn = g.mode === 'pan' ? 30 : 8;
        var to = sx < -th || (sx < -mn && fl && g.vx < 0) ? vi + 1 : sx > th || (sx > mn && fl && g.vx > 0) ? vi - 1 : vi;
        if (to === vi || !go(to)) { V.classList.add('is-anim'); sx = 0; if (g.mode === 'pan') clampPan(); applyZ(); }
      }
      else if (g.mode === 'dismiss') { if (Math.abs(dy) > 90) closeViewer(); else { V.classList.add('is-anim'); z = { tx: 0, ty: 0, s: 1 }; applyZ(); V.style.setProperty('--bgo', 1); } }
      g = null;
    }
    V.addEventListener('pointerup', up);
    V.addEventListener('pointercancel', up);
    V.addEventListener('wheel', function (e) {
      if (!vOpen) return; e.preventDefault(); V.classList.remove('is-anim');
      zoomAt(pt(e), Math.min(5, Math.max(1, z.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.012 : 0.003))))); clampPan(); applyZ();
    }, { passive: false });
  }
  function openViewer(btn) {
    var img = $('img', btn);
    if (!img || vOpen) return;
    if (!V) buildViewer();
    var tr = btn.closest('[data-hp-track]'), btns = tr ? $$('[data-hg-zoom]', tr) : [btn], strip = $('.hg-viewer__strip', V);
    strip.innerHTML = '';
    VI = btns.map(function (b) {
      var im = $('img', b), ar = im && im.naturalWidth ? im.naturalWidth / im.naturalHeight : (parseFloat(b.getAttribute('data-ar')) || 1);
      var el = document.createElement('img'), bx = fitBox(ar);
      el.alt = ''; el.decoding = 'async';
      el.style.left = bx.x + 'px'; el.style.top = bx.y + 'px'; el.style.width = bx.w + 'px'; el.style.height = bx.h + 'px';
      strip.appendChild(el);
      return { btn: b, el: el, b: bx, z: { tx: 0, ty: 0, s: 1 }, hi: false, src0: im ? (im.currentSrc || im.src) : '' };
    });
    vi = Math.max(0, btns.indexOf(btn)); sx = 0; vKeep = -1; vHid = img;
    setCap();
    V.hidden = false; V.style.setProperty('--bgo', 1); V.classList.remove('is-anim', 'is-slide');
    z = fromEl(); applyZ();
    img.style.visibility = 'hidden';
    vOpen = true; layer(true);
    document.documentElement.classList.add('hg-noscroll');
    hiRes(vi);
    kick(function () { V.classList.add('is-anim', 'is-on'); z = { tx: 0, ty: 0, s: 1 }; applyZ(); });
  }
  function closeViewer() {
    if (!vOpen) return;
    vOpen = false; layer(false);
    document.documentElement.classList.remove('hg-noscroll');
    clearTimeout(go.t);
    var img = vHid;
    var done = function () { V.hidden = true; if (img) img.style.visibility = ''; V.classList.remove('is-on', 'is-anim', 'is-slide'); };
    if (RM.matches || !img) { done(); return; }
    sx = 0; vKeep = -1;
    V.classList.remove('is-slide'); V.classList.add('is-anim'); V.classList.remove('is-on'); z = fromEl(); applyZ(); setTimeout(done, 480);
  }
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-hg-zoom]'); if (b) { e.preventDefault(); openViewer(b); } });
  document.addEventListener('keydown', function (e) { if (!vOpen || VI.length < 2) return; if (e.key === 'ArrowRight') go(vi + 1); else if (e.key === 'ArrowLeft') go(vi - 1); });

  /* ---------- 棚の作品：長押しでプレビュー（PCは右クリック） ---------- */
  var CX = null, cCard = null, cW = 0, suppress = false;
  function buildCtx() {
    CX = document.createElement('div');
    noLenis(CX);
    CX.className = 'hg-ctx'; CX.hidden = true;
    CX.innerHTML = '<div class="hg-ctx__bg"></div><img class="hg-ctx__img" alt=""><p class="hg-ctx__title"></p>' +
      '<div class="hg-ctx__menu hg-glass" role="menu"><a data-a="open" href="#">' + T('open_work', '作品を見る') + '<svg class="hg-i"><use href="#hg-open"/></svg></a>' +
      '<button type="button" data-a="save">' + T('save', '保存する') + '<svg class="hg-i"><use href="#hg-heart"/></svg></button>' +
      '<button type="button" data-a="share">' + T('share', '共有') + '<svg class="hg-i"><use href="#hg-share"/></svg></button></div>';
    document.body.appendChild(CX);
    $('.hg-ctx__bg', CX).addEventListener('click', function () { closeCtx(); });
    $('.hg-ctx__menu', CX).addEventListener('click', function (e) {
      var b = e.target.closest('[data-a]'); if (!b || !cCard) return;
      var a = b.getAttribute('data-a');
      if (a === 'share') { e.preventDefault(); share(cCard.getAttribute('data-title'), cCard.href); }
      if (a !== 'open') setTimeout(function () { closeCtx(); }, a === 'save' ? 350 : 0);
    });
  }
  function openCtx(card) {
    if (!CX) buildCtx();
    closeCtx(true);
    cCard = card;
    var img = $('img', card); if (!img) return;
    var r = img.getBoundingClientRect(), W = window.innerWidth, H = window.innerHeight, ar = r.width / r.height;
    var pw = Math.min(W - 72, ar >= 1 ? 320 : 250), ph = pw / ar;
    if (ph > H * 0.46) { ph = H * 0.46; pw = ph * ar; }
    var total = ph + 34 + 150, y0 = Math.max(24, (H - total) / 2 - 20), x0 = (W - pw) / 2;
    cW = pw;
    var ci = $('.hg-ctx__img', CX);
    ci.src = img.currentSrc || img.src; ci.style.width = pw + 'px'; ci.style.height = ph + 'px';
    var t = $('.hg-ctx__title', CX);
    t.textContent = [card.getAttribute('data-title'), card.getAttribute('data-artist'), card.getAttribute('data-price')].filter(Boolean).join(T('sep_dot', '・'));
    t.style.left = x0 + 'px'; t.style.top = (y0 + ph + 8) + 'px';
    var m = $('.hg-ctx__menu', CX);
    m.style.left = ((W - 250) / 2) + 'px'; m.style.top = (y0 + ph + 34) + 'px';
    $('[data-a="open"]', m).href = card.href;
    var sv = $('[data-a="save"]', m);
    if (card.getAttribute('data-handle')) { sv.hidden = false; sv.setAttribute('data-save', card.getAttribute('data-handle')); } else { sv.hidden = true; }
    CX.classList.add('is-snap'); CX.hidden = false;
    ci.style.transform = 'translate(' + r.left + 'px,' + r.top + 'px) scale(' + (r.width / pw) + ')';
    card.style.visibility = 'hidden';
    layer(true);
    kick(function () { CX.classList.remove('is-snap'); CX.classList.add('is-on'); ci.style.transform = 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)'; });
  }
  function closeCtx(instant) {
    if (!CX || !cCard) return;
    var card = cCard; cCard = null;
    CX.classList.remove('is-on'); layer(false);
    var done = function () { CX.hidden = true; card.style.visibility = ''; card.classList.remove('is-pressing'); };
    if (instant || RM.matches) { done(); return; }
    var r = $('img', card).getBoundingClientRect();
    $('.hg-ctx__img', CX).style.transform = 'translate(' + r.left + 'px,' + r.top + 'px) scale(' + (r.width / cW) + ')';
    setTimeout(done, 420);
  }
  function bindCards(root) {
    $$('.hg-rc', root).forEach(function (card) {
      if (card.getAttribute('data-bound')) return;
      card.setAttribute('data-bound', '1');
      var tm = null, p0 = null;
      var cancel = function () { clearTimeout(tm); tm = null; card.classList.remove('is-pressing'); };
      card.addEventListener('pointerdown', function (e) {
        if (e.button > 0 || e.pointerType === 'mouse') return;
        suppress = false; p0 = { x: e.clientX, y: e.clientY }; card.classList.add('is-pressing');
        tm = setTimeout(function () { tm = null; suppress = true; openCtx(card); }, 480);
      });
      card.addEventListener('pointermove', function (e) { if (tm && Math.hypot(e.clientX - p0.x, e.clientY - p0.y) > 8) cancel(); });
      card.addEventListener('pointerup', function () { if (tm) cancel(); });
      card.addEventListener('pointercancel', cancel);
      card.addEventListener('pointerleave', function () { if (tm) cancel(); });
      card.addEventListener('contextmenu', function (e) { e.preventDefault(); cancel(); suppress = true; openCtx(card); });
      card.addEventListener('click', function (e) { if (suppress) { suppress = false; e.preventDefault(); } });
    });
  }
  bindCards(document);

  /* ---------- 共有・戻る ---------- */
  function share(title, url) {
    if (navigator.share) { navigator.share({ title: title || document.title, url: url || location.href }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url || location.href).then(function () { toast(T('link_copied', 'リンクをコピーしました')); }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-hg-share]');
    if (s) { e.preventDefault(); share(s.getAttribute('data-title'), s.getAttribute('data-url')); return; }
    var b = e.target.closest('[data-hg-back]');
    if (b) {
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) { e.preventDefault(); history.back(); }
      } catch (err) {}
    }
  });
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'hg-toast hg-glass'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  /* ---------- セグメント（予算など）：押すとその場で中身が入れ替わる ---------- */
  $$('[data-hg-switch]').forEach(function (root) {
    var seg = $('.hg-seg', root), btns = $$('.hg-seg button', root), panes = $$('[data-pane]', root), lead = $$('[data-lead]', root);
    var at = btns.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    if (at < 0) at = 0;
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (i === at) return;
        var dir = i > at ? 'l' : 'r', old = panes[at], nw = panes[i];
        at = i;
        seg.style.setProperty('--si', i);
        btns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i); });
        var th = $('.hg-seg__thumb', seg); th.classList.remove('is-moving'); void th.offsetWidth; th.classList.add('is-moving');
        lead.forEach(function (l, j) { l.hidden = j !== i; });
        var show = function () { panes.forEach(function (p, j) { p.hidden = j !== i; p.classList.remove('is-out-l', 'is-out-r', 'is-in-l', 'is-in-r'); }); nw.scrollLeft = 0; if (!RM.matches) nw.classList.add(dir === 'l' ? 'is-in-r' : 'is-in-l'); bindCards(nw); };
        if (RM.matches || !old) { show(); return; }
        old.classList.add('is-out-' + dir);
        setTimeout(show, 190);
      });
    });
  });

  /* ---------- トップの棚（スマホ2列）：「すべて見る」で別ページに行かず、その場で残りを下に出す（2026-10-05） ---------- */
  $$('[data-hh-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = document.getElementById(b.getAttribute('aria-controls'));
      if (!g) return;
      /* 2026-10-13 菅原「押すと画面が勝手に7点目まで動く」：ブラウザのスクロール位置の自動補正（scroll anchoring）が
         ボタンより下を基準に画面を送っていた → 開く間だけ補正を止め、見えていた6点はその場・続きがその下に出るように */
      var root = document.documentElement, top0 = g.getBoundingClientRect().top;
      root.style.overflowAnchor = 'none';
      g.classList.add('is-all');
      b.setAttribute('aria-expanded', 'true');
      b.hidden = true;
      bindCards(g);
      var dy = g.getBoundingClientRect().top - top0;
      if (Math.abs(dy) > 1) window.scrollBy(0, dy);
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.style.overflowAnchor = ''; }); });
    });
  });

  /* ---------- 部屋での大きさ（作品の実寸で、3つの場面の壁に掛ける） ---------- */
  var SEP = '[x×X✕╳*]', NUM = '([0-9]+(?:\\.[0-9]+)?)';
  var PAIR = new RegExp(NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM);
  var TRIPLE = new RegExp(NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM);
  function parseDim(raw, ar, orient, stand) {
    if (!raw) return null;
    var s = String(raw), t = TRIPLE.exec(s), m = t || PAIR.exec(s);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    if (!(a > 0) || !(b > 0)) return null;
    var c = t ? parseFloat(m[3]) : 0;
    if (/mm/i.test(s) || !/cm/i.test(s)) { a /= 10; b /= 10; c /= 10; }
    /* 置いて飾る立体は記載どおり 高さ×幅×奥行（縦横の判定はしない） */
    if (stand) return { wide: b, high: a, deep: c };
    var long = Math.max(a, b), short = Math.min(a, b), land;
    if (orient === 'land' || orient === 'port') land = orient === 'land';
    else if (ar > 0 && Math.abs(ar - 1) >= 0.03) land = ar > 1;
    else land = b >= a;
    return { wide: land ? long : short, high: land ? short : long };
  }
  $$('[data-hg-room]').forEach(function (box) {
    var room = $('.hg-room', box);
    var stand = box.getAttribute('data-stand') === '1';
    var d = parseDim(box.getAttribute('data-dim'), parseFloat(box.getAttribute('data-ar')) || 0, box.getAttribute('data-orient'), stand);
    if (!room || !d) return;
    /* 壁の幅は作品の大きさに合わせて広げる（大きな作品が壁からはみ出さないように）。px＝人の左端（cm）の既定 */
    var S = {
      living: { wall: Math.max(320, d.wide * 2.2), cy: Math.max(128, 80 + 12 + d.high / 2), px: -150 },
      entry: { wall: Math.max(200, d.wide * 2.4), cy: Math.max(138, 80 + 12 + d.high / 2), px: 52 },
      desk: { wall: Math.max(230, d.wide * 2.2), cy: Math.max(124, 72 + 16 + d.high / 2), px: 66 }
    };
    /* 置いて飾る立体（2026-10-10）：作品の底を家具の天板（サイドボード60・玄関の台80・机74cm）に合わせる */
    if (stand) { S.living.cy = 60 + d.high / 2; S.entry.cy = 80 + d.high / 2; S.desk.cy = 74 + d.high / 2; }
    /* 図の中に寸法を書く（2026-09-29）：床の帯に家具の幅の寸法線、人の頭の上に身長。
       そのぶん床の帯と頭の上に余白を取り、人の全身と床がいつも見える縮尺にする（以前は玄関・デスクで頭と足が切れていた） */
    var FLOOR = 26, TOP = 24;
    var extras = $$('.hg-room__art.is-extra', room), gapCm = 6, series = false, scene = 'living', lab = $('.hg-room__lab', room);
    /* 最初に見せる部屋を作品の大きさで選ぶ（2026-10-18、10/16分析の案②。以前はリビング固定で小品が豆粒に見えていた）：
       長い辺 〜40cm＝デスク／〜80cm＝玄関／それ以上＝リビング */
    var longest = Math.max(d.wide, d.high);
    scene = longest <= 40 ? 'desk' : longest <= 80 ? 'entry' : 'living';
    room.style.setProperty('--aw', d.wide); room.style.setProperty('--ah', d.high);
    var cap = $('.hg-room-cap', box), btns = $$('.hg-seg button', box), seg = $('.hg-seg', box);
    function set(n, instant) {
      scene = n;
      var s = S[n], W = room.clientWidth, H = room.clientHeight;
      if (!W) return;
      var total = d.wide * (extras.length + 1) + gapCm * extras.length;
      var need = series ? total * 1.25 : 0, half = (series ? total : d.wide) / 2;
      var wall = Math.max(s.wall, need), base = Math.min(W / wall, (H - FLOOR - TOP) / Math.max(165, s.cy + d.high / 2));
      /* 人と頭の上の「身長165cm」は、作品に重ならず、図の端からもはみ出さない位置・縮尺に。
         文字の幅は px で決まっているので、縮尺（ppc）が決まると cm の幅が変わる → 3回まわして収める */
      var LW = ((lab && lab.offsetWidth) || 72) + 8, room2 = W / 2 - 6, ppc = base, px = s.px;
      for (var k = 0; k < 3; k++) {
        var lh = LW / 2 / ppc;
        if (n === 'living') {
          px = Math.min(s.px, -half - 8 - 46, -half - 4 - 23 - lh);
          ppc = Math.min(base, room2 / -px, (room2 - LW / 2) / Math.max(1, -px - 23));
        } else {
          px = Math.max(s.px, half + 8, half + 4 - 23 + lh);
          ppc = Math.min(base, room2 / (px + 46), (room2 - LW / 2) / Math.max(1, px + 23));
        }
      }
      var bcm = -FLOOR / ppc;
      if (instant) room.style.transition = 'none';
      room.style.setProperty('--ppc', ppc.toFixed(4)); room.style.setProperty('--bcm', bcm.toFixed(2));
      room.style.setProperty('--cy', s.cy); room.style.setProperty('--px', px);
      extras.forEach(function (x, k) {
        var side = k % 2 ? 1 : -1, step = Math.floor(k / 2) + 1;
        x.style.setProperty('--o', series ? side * step * (d.wide + gapCm) : 0);
      });
      if (instant) { void room.offsetWidth; room.style.transition = ''; }
      $$('.hg-room__scene', room).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-scene') === n); });
      var i = Object.keys(S).indexOf(n);
      if (seg) seg.style.setProperty('--si', i);
      btns.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i); });
      var r = function (v) { return Math.round(v * 10) / 10; };
      if (cap) cap.textContent = series
        ? T('room_series', '{n}点を並べて 幅{w}cm').replace('{n}', extras.length + 1).replace('{w}', r(total))
        : stand ? T('room_stand', '作品 高さ{h} × 幅{w}{d}cm').replace('{h}', r(d.high)).replace('{w}', r(d.wide)).replace('{d}', d.deep ? T('room_depth', ' × 奥行{d}').replace('{d}', r(d.deep)) : '')
        : T('room_flat', '作品 縦{h} × 横{w}cm').replace('{h}', r(d.high)).replace('{w}', r(d.wide));
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { var th = $('.hg-seg__thumb', box); th.classList.remove('is-moving'); void th.offsetWidth; th.classList.add('is-moving'); set(b.getAttribute('data-scene')); }); });
    var sw = $('.hg-sw', box);
    if (sw) sw.addEventListener('click', function () { series = !series; sw.setAttribute('aria-checked', series); room.classList.toggle('is-series', series); set(scene); });
    var sheet = box.closest('.hg-sheet');
    if (sheet) sheet.addEventListener('hg:open', function () { window.requestAnimationFrame(function () { set(scene, true); }); });
    window.addEventListener('resize', function () { set(scene, true); });
    set(scene, true);
  });

  /* ---------- 作品ページ：お届けまでの総額の目安を行に出す（計算は pdp-extras.js） ---------- */
  var tot = $('[data-hg-total]');
  if (tot) {
    var src = $('[data-cost-sum]');
    var paint = function () {
      var v = src ? src.textContent.trim() : '';
      tot.textContent = /^¥/.test(v) ? v + T('price_from_suffix', '〜') : ($('[data-cost-over]') && !$('[data-cost-over]').hidden ? T('quote_individually', '個別にお見積り') : '');
    };
    paint();
    var area = $('[data-cost-area]'); if (area) area.addEventListener('change', function () { tot.textContent = (src ? src.textContent.trim() : ''); });
  }

  /* ---------- 作品ページ：画像の列（スマホは指で左右にめくる・サムネを押すとその画像へ。2026-10-05） ---------- */
  var HT = $('[data-hp-track]');
  if (HT) {
    var hThumbs = $$('[data-hg-thumb]'), hRq = 0;
    var hMark = function (i) { hThumbs.forEach(function (x, j) { x.classList.toggle('is-on', j === i); }); };
    hThumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        HT.scrollTo({ left: i * HT.clientWidth, behavior: RM.matches ? 'auto' : 'smooth' }); hMark(i);
        /* 読み込み中などで滑らかな移動が途中で止まったら、その画像へ直接 */
        setTimeout(function () { if (Math.round(HT.scrollLeft / Math.max(1, HT.clientWidth)) !== i) HT.scrollLeft = i * HT.clientWidth; }, 700);
      });
    });
    HT.addEventListener('scroll', function () { cancelAnimationFrame(hRq); hRq = requestAnimationFrame(function () { hMark(Math.round(HT.scrollLeft / Math.max(1, HT.clientWidth))); }); }, { passive: true });
  }

  /* ---------- トップ：展示カードが全画面に広がる ---------- */
  var ST = $('[data-hh-story]'), stSc = ST && $('.hh-story__sc', ST), stCard = null, stOpen = false;
  if (ST) { document.body.appendChild(ST); noLenis(ST); }
  /* 展示の画面の最終位置（スマホ＝全画面、PC＝中央のパネル）。transform を外した状態で測る */
  function storyBox() {
    var t = ST.style.transform, c = ST.style.clipPath;
    ST.style.transform = 'none'; ST.style.clipPath = 'none';
    var r = ST.getBoundingClientRect();
    ST.style.transform = t; ST.style.clipPath = c;
    return r;
  }
  function storyRad() { return MOBILE.matches ? 0 : 24; }
  function storyFrom(card) {
    var b = storyBox(), r = card.getBoundingClientRect(), k = r.width / b.width, visH = r.height / k;
    return { tf: 'translate(' + (r.left - b.left) + 'px,' + (r.top - b.top) + 'px) scale(' + k + ')', clip: 'inset(0px 0px ' + Math.max(0, b.height - visH) + 'px 0px round ' + (24 / k) + 'px)' };
  }
  /* カードの中身は展示の画面の上部と同じもの。画面の幅で組んで、カードの幅まで縮める */
  function sizeCards() {
    var cards = $$('.hh-tcard');
    if (!cards.length) return;
    /* PCは横一列で2〜3枚並べるので、中身を480px幅で組んで縮める（720pxで組むと文字が小さくなりすぎる。2026-10-10） */
    var sw = MOBILE.matches ? window.innerWidth : 480;
    var hs = [];
    cards.forEach(function (c) {
      var x = $('.hh-xtop', c); if (!x) return;
      var k = c.clientWidth / sw;
      c.style.setProperty('--sw', sw + 'px'); c.style.setProperty('--k', k);
      x.style.minHeight = '';
      c.style.height = Math.round(x.offsetHeight * k) + 'px';
      hs.push([c, x, k]);
    });
    /* 高さを一番高いカードに揃える（題名の行数で凸凹しないように）。帯の色は中身を伸ばして下まで塗る。
       以前はPCの横一列だけで、スマホは題名が2行の展示だけ縦に長くなっていた（2026-10-19 菅原「カードのサイズを揃えて」） */
    var max = 0;
    hs.forEach(function (h) { max = Math.max(max, h[0].offsetHeight); });
    hs.forEach(function (h) { h[0].style.height = max + 'px'; h[1].style.minHeight = Math.ceil(max / h[2]) + 'px'; });
  }
  /* 展示の画面の「展示中の作品」を左右2列に、並び順のまま1点ずつ「低い方の列」へ入れる（2026-10-27）。
     以前は CSS の columns:2＝左の列を下まで埋めてから右の列へ、で、後ろにまとめた売約が右の列に固まった
     （菅原「景の右列が全て売約済みで違和感」）。画像は width/height 属性で読み込み前から高さが決まるので、入れながら測る。
     測るので、画面を表示（hidden を外した）後に呼ぶ */
  function sgridLanes(root) {
    $$('.hh-sgrid', root).forEach(function (g) {
      if (g.classList.contains('is-lanes')) return;
      var cards = $$('.hg-rc', g);
      if (cards.length < 2) return;
      g.textContent = '';
      g.classList.add('is-lanes');
      var L = [document.createElement('div'), document.createElement('div')];
      L.forEach(function (c) { c.className = 'hh-slane'; g.appendChild(c); });
      cards.forEach(function (c) { (L[0].offsetHeight <= L[1].offsetHeight ? L[0] : L[1]).appendChild(c); });
    });
  }
  sizeCards();
  window.addEventListener('resize', sizeCards);
  window.addEventListener('load', sizeCards);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeCards);
  function openStory(card) {
    if (!ST || stOpen) return;
    var tpl = $(card.getAttribute('data-story'));
    if (!tpl) { window.location.href = card.getAttribute('href'); return; }
    stOpen = true; stCard = card;
    stSc.innerHTML = tpl.innerHTML;
    /* スマホはカードがそのまま広がるので、揃えて伸ばした帯の高さも引き継ぐ（違うと広がる瞬間に帯の下が白く欠ける） */
    var cx = $('.hh-xtop', card), sx = $('.hh-xtop', stSc);
    if (MOBILE.matches && cx && sx) sx.style.minHeight = cx.style.minHeight;
    bindCards(stSc);
    stSc.scrollTop = 0;
    ST.hidden = false;
    sgridLanes(stSc);
    ST.classList.remove('is-anim', 'is-open');
    /* スマホ：カードがそのまま全画面に広がる（拡大＋切り抜き）。
       PC：中央のパネルをふわっと出すだけ（不透明度と少しの移動は CSS）。PC で広がる動きにすると描画が止まり、
       パネルがカードと同じ位置に重なったまま「押しても何も出ない」ように見えた（2026-09-30） */
    if (MOBILE.matches) {
      var f = storyFrom(card);
      ST.style.transform = f.tf; ST.style.clipPath = f.clip;
      card.style.visibility = 'hidden';
    } else {
      ST.style.transform = ''; ST.style.clipPath = '';
      scrim.classList.add('is-on', 'is-deep');
    }
    layer(true);
    document.documentElement.classList.add('hg-noscroll');
    kick(function () {
      ST.classList.add('is-anim', 'is-open');
      if (MOBILE.matches) { ST.style.transform = 'none'; ST.style.clipPath = 'inset(0px 0px 0px 0px round ' + storyRad() + 'px)'; }
    });
    /* 保険：ブラウザによってはアニメーションの時計が進まず、幕もパネルも透明のまま「何も出ない」ことがある。
       0.7秒（動きはどれも0.6秒以内に終わる）経っても開いていれば、動きを打ち切って表示し切った状態にする */
    setTimeout(function () {
      if (!stOpen || stCard !== card) return;
      [ST, scrim, $('.hh-story__body', ST), $('.hh-story__x', ST)].forEach(function (el) {
        if (!el) return;
        el.style.transition = 'none'; void el.offsetWidth; el.style.transition = '';
      });
    }, 700);
  }
  function closeStory() {
    if (!stOpen) return;
    stOpen = false;
    var card = stCard;
    layer(false);
    if (!cur) scrim.classList.remove('is-on', 'is-deep');
    document.documentElement.classList.remove('hg-noscroll');
    var done = function () { ST.hidden = true; card.style.visibility = ''; ST.style.transform = ST.style.clipPath = ''; ST.classList.remove('is-anim', 'is-open'); };
    if (RM.matches) { done(); return; }
    ST.classList.remove('is-open'); ST.classList.add('is-anim');
    if (!MOBILE.matches) { setTimeout(done, 320); return; }
    stSc.scrollTop = 0;
    var f = storyFrom(card);
    ST.style.transform = f.tf; ST.style.clipPath = f.clip;
    setTimeout(done, 560);
  }
  if (ST) {
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-story]');
      if (c && !e.metaKey && !e.ctrlKey) { e.preventDefault(); openStory(c); }
    });
    $('[data-hh-story-x]', ST).addEventListener('click', closeStory);
    /* 一番上で下へ引くと縮んで戻る */
    var g = null;
    var start = function (y) { if (stSc.scrollTop > 0) return; g = { y0: y, dy: 0 }; ST.classList.remove('is-anim'); };
    var move = function (y, ev) {
      if (!g) return;
      g.dy = y - g.y0;
      if (g.dy <= 0) { ST.style.transform = 'none'; return; }
      if (ev && ev.cancelable) ev.preventDefault();
      var s = Math.max(0.82, 1 - g.dy / 1400), W = window.innerWidth;
      ST.style.transform = 'translate(' + (W * (1 - s) / 2) + 'px,' + (g.dy * 0.5) + 'px) scale(' + s + ')';
      ST.style.clipPath = 'inset(0px 0px 0px 0px round ' + (g.dy / 5) + 'px)';
    };
    var end = function () {
      if (!g) return;
      var d = g.dy; g = null;
      if (d > 110) closeStory();
      else { ST.classList.add('is-anim'); ST.style.transform = 'none'; ST.style.clipPath = 'inset(0px 0px 0px 0px round ' + storyRad() + 'px)'; }
    };
    stSc.addEventListener('touchstart', function (e) { start(e.touches[0].clientY); }, { passive: true });
    stSc.addEventListener('touchmove', function (e) { move(e.touches[0].clientY, e); }, { passive: false });
    stSc.addEventListener('touchend', end);
    stSc.addEventListener('touchcancel', end);
  }

  /* ---------- トップ：PCの横一列の矢印（2026-10-10）。1回で見えている枚数ぶん送る・端では隠す ---------- */
  $$('[data-hh-today]').forEach(function (t) {
    var wrap = t.parentNode, prev = $('[data-hh-prev]', wrap), next = $('[data-hh-next]', wrap);
    if (!prev || !next) return;
    var step = function () {
      var c = t.querySelector('.hh-tcard'); if (!c) return t.clientWidth;
      var per = Math.max(1, Math.floor((t.clientWidth + 24) / (c.offsetWidth + 24)));
      return per * (c.offsetWidth + 24);
    };
    var sync = function () {
      var max = t.scrollWidth - t.clientWidth - 2;
      prev.hidden = t.scrollLeft <= 2; next.hidden = t.scrollLeft >= max;
      var c = t.querySelector('.hh-tcard');
      if (c) wrap.style.setProperty('--arrow-y', (c.offsetTop + c.offsetHeight * 0.42 - 22) + 'px');
    };
    prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
    t.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync); window.addEventListener('load', sync);
    sync();
  });

  /* ---------- トップ：展示カードの点（何枚目か） ---------- */
  $$('[data-hh-today]').forEach(function (t) {
    var dots = $$('i', t.parentNode.querySelector('.hh-dots') || document.createElement('div'));
    if (!dots.length) return;
    t.addEventListener('scroll', function () {
      var c = t.querySelector('.hh-tcard'); if (!c) return;
      var i = Math.round(t.scrollLeft / (c.offsetWidth + 12));
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }, { passive: true });
  });

  /* ---------- トップ：展示カードの下の帯の色を、キービジュアルの下の方から取る ---------- */
  $$('[data-hh-band]').forEach(function (x) {
    var img = $('img', x);
    if (!img || x.closest('template')) return;
    var run = function () {
      try {
        var c = document.createElement('canvas'), w = 24, h = 24; c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(img, 0, img.naturalHeight * 0.86, img.naturalWidth, img.naturalHeight * 0.14, 0, 0, w, h);  /* 一番下の帯＝ポスターなら紙の色、写真なら足元の色 */
        var d = ctx.getImageData(0, 0, w, h).data, r = 0, g2 = 0, b = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { r += d[i]; g2 += d[i + 1]; b += d[i + 2]; n++; }
        r /= n; g2 /= n; b /= n;
        var lum = 0.2126 * r + 0.7152 * g2 + 0.0722 * b;
        /* 暗い絵は少し沈め、明るい絵は紙の白に寄せる。帯の文字は明るさで白/墨を選ぶ */
        var k = lum > 150 ? 0.35 : 0.72, base2 = lum > 150 ? 250 : 12;
        var mix = function (v) { return Math.round(v * k + base2 * (1 - k)); };
        var col = 'rgb(' + mix(r) + ',' + mix(g2) + ',' + mix(b) + ')';
        var fg = lum > 150 ? '#1d1d1f' : '#ffffff';
        $$('[data-hh-band="' + x.getAttribute('data-hh-band') + '"]').forEach(function (y) { y.style.setProperty('--band', col); y.style.setProperty('--bandfg', fg); });
        var tpl = $('#hh-story-' + x.getAttribute('data-hh-band'));
        if (tpl) tpl.innerHTML = tpl.innerHTML.replace(/--band:[^;"]*;--bandfg:[^;"]*;?/, '--band:' + col + ';--bandfg:' + fg + ';');
      } catch (e) { /* 画像が読めない時は既定の墨の帯のまま */ }
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run);
  });

  /* ---------- トップ：メニュー（☰）のシート ---------- */
  window.HG = { openSheet: openSheet, closeSheet: closeSheet, toast: toast, bindCards: bindCards };
})();
